<template>
  <div>
    <WsCard 
      :style="_borderLeft"
      class="my-5 mx-0"
    >
      <v-container class="py-0 px-5">
        <v-row no-gutters>
          <v-col
            v-if="title"
            align-self="center"
            :style="'min-width: 32px;'"
            class="flex-grow-0"
          >
            <div class="
                text-subtitle-1
                font-weight-bold
              "
            >{{title}}</div>
          </v-col>
          <v-col 
            align-self="center" 
            class="flex-grow-1 flex-shrink-0"
          >
            <WsStateForm
              v-if="fields"
              :generalFields="fields"
              :value="value"
              @input="$_onInputForm($event)"
            ></WsStateForm>
          </v-col>
          <v-col 
            align-self="center"
            class="flex-grow-0"
          >
            <WsIconBtn
              v-if="deletable"
              @click="$_deleteAlert()"
              :size="40"
              class="ml-1 mr-1"
              tooltip="刪除"
            >mdi-delete</WsIconBtn>
          </v-col>
        </v-row>
      </v-container>
    </WsCard>
    <WsAlertDialog
      ref="deleteDialog"
      title="確定要刪除嗎？"
      :description="description"
      @submit="$_onDelete()"
    />
  </div>
</template>

<script>
export default {
  methods: {
    $_onInputForm($event) {
      const _value = { ...this.value, ...$event };
      this.$emit("input", _value);
    },
    $_deleteAlert() {
      this.$refs.deleteDialog.open();
    },
    $_onDelete() {
      this.$emit("delete");
      this.$refs.deleteDialog.close();
    },
  },
  props: {
    title: {
      type: String,
    },
    value: {
      type: Object,
    },
    fields: {
      type: Object,
    },
    deletable: {
      type: Boolean,
    },
    type: {
      type: String,
    },
    description: {
      type: String,
    }
  },
  computed: {
    _borderLeft() {
      let border = ''
      if (this.type === "chapter") {
        border = "border-left: 8px #0b4c6e solid;"
      } else if (this.type === "section") {
        border = "border-left: 8px #217fb0 solid;"
      }
      return border
    }
  }
};
</script>